export const LOADING_CONTAINER_MIN_HEIGHT = '400px'

// Empirical offset that aligns the sourcing drill-down's left border with the
// expansion caret. Derived from EUI's expanded row cell padding + button centering
// within the expander column — not directly expressible as a design token.
export const DRILL_DOWN_CARET_INDENT = 12

export const SMALL_GAP = '4px'
export const LARGE_GAP = '8px'

export const TITLE_MARGIN = {
	marginTop: 0,
	marginBottom: '8px',
}

// Shown in place of a request's fulfilling DC when it has none: a stock request
// sent without a "To" location, which inventory-api routes automatically.
export const AUTOMATIC_FULFILLING_INVENTORY_LABEL = 'Supply Chain Team'

// The main distribution center (inventory location 9814). Fulfills every request
// whose requesting location no mini-DC serves, and is always offered alongside the
// serving mini-DCs when one does.
export const MAIN_DISTRIBUTION_CENTER_ID = '9814'
